import {Text} from "../@FreeModel";
import React from "react";

const Footer = (): React.ReactElement => {
  return <div className="help-box">
    <Text size="sm" color="gray" lineHeight="sm">
      If you have any additional questions for Freemodel, email
      <Text
        size="sm"
        color="blue"
        lineHeight="sm"
        style={{cursor: 'pointer'}}
        inline
        onClick={() => {
          window.location.href = "mailto:contractors@freemodel.com"
        }}
      >
        contractors@freemodel.com
      </Text>
      for more info.
    </Text>
  </div>
}

export default Footer
